import { createContext, useContext } from "react";

export type Theme = "light" | "dark" | "system";

export interface ThemeState {
  /** What the person chose. */
  readonly theme: Theme;
  /** What is shown now ("system" resolved to light or dark). */
  readonly resolved: "light" | "dark";
  readonly setTheme: (theme: Theme) => void;
}

export const ThemeContext = createContext<ThemeState | null>(null);

export function useTheme(): ThemeState {
  const state = useContext(ThemeContext);
  if (state === null) throw new Error("useTheme must be used inside <ThemeProvider>");
  return state;
}
